import { createFileRoute } from '@tanstack/react-router'

import { SameDayRepeatsScreen } from './-components/same-day-repeats-screen.tsx'

export const Route = createFileRoute(
  '/transaction-monitoring/same-day-repeats'
)({
  component: SameDayRepeatsScreen
})
